import { Routes } from '@angular/router';
import { PublicComponent } from './public/public.component';
import { LoginComponent } from './public/login/login.component';
import { RecoveryPasswordComponent } from './public/recovery-password/recovery-password.component';
import { NewPasswordComponent } from './public/new-password/new-password.component';

const publicRoutes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'recuperar-password', component: RecoveryPasswordComponent },
  { path: 'nuevo-password/:token', component: NewPasswordComponent }
];

export const mainRoutes: Routes = [
  { path: '', redirectTo: 'public', pathMatch: 'full' },
  { path: 'public', component: PublicComponent, children: publicRoutes }
]




// WEBPACK FOOTER //
// ./src/app/app.routes.ts